<ng-container *ngIf="isInErrorState; else hint">
  <ng-content select="[form-field-help-errors]"></ng-content>
</ng-container>

<ng-template #hint>
  <ng-content select="[form-field-help-hint]"></ng-content>
</ng-template>
